<template>
    <div class="code-detail">
        
    </div>
</template>
<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true
            }
        }
    };
</script>
<style lang="postcss">
.code-detail {
}
</style>



// WEBPACK FOOTER //
// CodeDetail.vue?8e5c7aa0